import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import axios from "axios";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { Button, Grid, Switch } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import config from "../../config";
import canawhoLogoImgNotFound from "../../assets/img/logo-black-img-not-found.png";
import ImageUpload from "../image-upload.component";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Dropzone from "react-dropzone";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";

const BACKEND_URL = config.backend.host;

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "90%",
  },
  textField: {
    marginLeft: 10,
    marginRight: 10,
    width: "250px",
  },
  dense: {
    marginTop: 16,
  },
  menu: {
    width: 200,
  },
  button: {
    margin: theme.spacing(),
  },
  leftIcon: {
    marginRight: theme.spacing(),
    fontSize: 20,
  },
  input: {
    display: "none",
  },
  inputSmall: {
    width: "94%",
    marginLeft: theme.spacing(),
  },
  inputLarge: {
    width: "98%",
    marginLeft: theme.spacing(),
  },
  card: {
    maxWidth: 345,
  },
  media: {
    height: 140,
  },
  notchedOutline: {
    borderWidth: "1px",
    borderColor: "#000 !important",
  },
  fieldset: {
    borderColor: "#F6227F",
    borderWidth: 1,
    borderRadius: 7,
    width: "90%",
    marginLeft: "15%",
    marginTop: "3%",
  },
  legend_text: {
    color: "black",
    fontFamily: "Open Sans",
    fontSize: 20,
    fontWeight: "700",
  },
  image_viewer: {
    display: "inline-block",
    width: "200px",
    height: "200px",
    overflow: "hidden",
    textAlign: "center",
    marginTop: "2%",
    borderColor: "#BCBCBC",
    border: "solid 2px",
    borderRadius: 4,
  },
});

const btype_arr = [
  {
    value: "Cannabis Brand",
    label: "Cannabis Brand",
  },
  {
    value: "Cannabis Retail ",
    label: "Cannabis Retail ",
  },
  {
    value: "Cannabis Clinic",
    label: "Cannabis Clinic",
  },
  {
    value: "Non-Cannabis Business",
    label: "Non-Cannabis Business",
  },
];

const license_arr = [
  {
    value: "Retail",
    label: "Retail",
  },
  {
    value: "Production",
    label: "Production",
  },
  {
    value: "Recreational Brand",
    label: "Recreational Brand",
  },
  {
    value: "Medical Brand",
    label: "Medical Brand",
  },
  {
    value: "Other",
    label: "Other",
  },
];
class BrandAdd extends Component {
  state = {
    name: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    businessType: "",
    licenseType: "",
    addOne: "",
    addTwo: "",
    postalCode: "",
    city: "",
    province: "",
    country: "",
    about: "",
    website: "",
    banner: "",
    logo: "",
    licenseNo: "",
    is_registered: false,
    title: "Add",
    isEdit: false,
    loadingImage: false,
  };

  constructor(props) {
    super(props);
    // this.btnSaveOnClick = this.btnSaveOnClick.bind(this);
    this.btnCancelOnClick = this.btnCancelOnClick.bind(this);
    if (props.match.params.id) {
      axios
        .get(BACKEND_URL + "/brand/" + props.match.params.id)
        .then((response) => this.loadData(response.data))
        .catch((err) => {
          //  console.log(err)
        });
    }
  }
  loadData(brand) {
    // console.log(brand);
    this.setState({
      _id: brand._id,
      name: brand.name,
      firstName: brand.contact.first_name ? brand.contact.first_name : "",
      lastName: brand.contact.last_name ? brand.contact.last_name : "",
      phoneNumber: brand.contact.phone_number ? brand.contact.phone_number : "",
      email: brand.contact.email ? brand.contact.email : "",
      businessType: brand.type ? brand.type : "",
      licenseType: brand.license_type ? brand.license_type : "",
      addOne: brand.address_line1 ? brand.address_line1 : "",
      addTwo: brand.address_line2 ? brand.address_line2 : "",
      postalCode: brand.postal_code ? brand.postal_code : "",
      city: brand.city,
      province: brand.province,
      country: brand.country,
      about: brand.about,
      website: brand.website,
      banner: brand.banner,
      logo: brand.logo,
      licenseNo: brand.license_number ? brand.license_number : "",
      is_registered: brand.is_registered,
      title: "Edit",
      isEdit: true,
    });
  }

  btnCancelOnClick(e) {
    e.preventDefault();
    this.props.history.goBack();
  }

  btnSaveOnClick() {
    const {
      _id,
      name,
      firstName,
      lastName,
      phoneNumber,
      email,
      businessType,
      licenseType,
      addOne,
      addTwo,
      postalCode,
      city,
      province,
      country,
      about,
      website,
      banner,
      logo,
      is_registered,
      licenseNo,
      isEdit,
    } = this.state;

    const obj = {
      name: name,
      contact: {
        first_name: firstName,
        last_name: lastName,
        phone_number: phoneNumber,
        email: email,
      },
      type: businessType,
      license_type: licenseType,
      address_line1: addOne,
      address_line2: addTwo,
      postal_code: postalCode,
      city: city,
      province: province,
      country: country,
      about: about,
      website: website,
      license_number: licenseNo,
      banner: banner,
      logo: logo,
      is_registered: is_registered,
    };
    //TODO: show message DONE with snackbar
    if (isEdit) {
      // console.log("LOOK HERE", obj, _id);
      axios
        .put(BACKEND_URL + `/brand/${_id}`, obj)
        .then((res) => {
          this.saveSuccess(res);
          // console.log(res);
        })
        .catch((e) => {
          // console.log(e);
          alert(`Error: ${e.message} | ${e.response.data.message}`);
        });
    } else {
      axios
        .post(BACKEND_URL + "/brand", obj)
        .then((res) => this.saveSuccess(res))
        .catch((e) =>
          alert(`Error: ${e} | Response: ${e.response.data.message}`)
        );
    }
  }

  saveSuccess(response) {
    //TODO: Set a snack bar with Redux to show messages after saving
    alert("Saved");
    this.props.history.goBack();
  }

  handleChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

  handleChangeRegistered = () => {
    this.setState({ is_registered: !this.state.is_registered });
  };

  cbSetLogoNewLink(link) {
    this.setState({ logo: link });
  }

  handleDrop = (file) => {
    if (!file) {
      return;
    }

    this.setState({ loadingImage: true }, () => {
      let reader = new FileReader();

      reader.onloadend = () => {
        this.setState({ loadingImage: false, logo: reader.result });
      };

      reader.readAsDataURL(file);
    });
  };

  handleFileChange = (event) => {
    const { target } = event;
    const { files } = target;

    if (files && files[0]) {
      var reader = new FileReader();

      reader.onloadstart = () => this.setState({ loadingImage: true });

      reader.onload = (event) => {
        this.setState({
          logo: event.target.result,
          loadingImage: false,
        });
      };

      reader.readAsDataURL(files[0]);
    }
  };

  render() {
    const { classes } = this.props;
    const { loadingImage, logo } = this.state;
    return (
      <div className={classes.root}>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          style={{ minHeight: "5vh" }}
        >
          <Typography variant="h4" gutterBottom>
            {this.state.title} Brand
          </Typography>
        </Grid>
        <Grid container spacing={24}>
          {/* <form
            className={classes.container}
            autoComplete="off"
            // onSubmit={this.btnSaveOnClick}
          > */}
          <fieldset className={classes.fieldset}>
            <legend className={classes.legend_text}>Contact Information</legend>
            <Grid container direction="row" justify="space-evenly">
              <Grid item md={6}>
                <TextField
                  id="firstName"
                  label="First Name"
                  className={classes.inputSmall}
                  margin="normal"
                  variant="outlined"
                  value={this.state.firstName}
                  onChange={this.handleChange("firstName")}
                />
              </Grid>
              <Grid item md={6}>
                <TextField
                  id="lastName"
                  label="Last Name"
                  className={classes.inputSmall}
                  margin="normal"
                  variant="outlined"
                  value={this.state.lastName}
                  onChange={this.handleChange("lastName")}
                />
              </Grid>
              <Grid item md={6}>
                <TextField
                  id="phoneNumber"
                  label="Phone Number"
                  className={classes.inputSmall}
                  margin="normal"
                  variant="outlined"
                  value={this.state.phoneNumber}
                  onChange={this.handleChange("phoneNumber")}
                />
              </Grid>
              <Grid item md={6}>
                <TextField
                  id="email"
                  label="Email"
                  className={classes.inputSmall}
                  margin="normal"
                  variant="outlined"
                  value={this.state.email}
                  onChange={this.handleChange("email")}
                />
              </Grid>
            </Grid>
          </fieldset>
          <fieldset className={classes.fieldset}>
            <legend className={classes.legend_text}>
              Business Information
            </legend>
            <Grid container direction="row" justify="space-evenly">
              <Grid
                container
                direction="row"
                justify="space-evenly"
                style={{ marginLeft: 10 }}
              >
                <Grid item md={6}>
                  <TextField
                    style={{ width: "95%" }}
                    variant="outlined"
                    margin="normal"
                    required
                    select
                    label="Business Type"
                    type="text"
                    id="businessType"
                    value={this.state.businessType}
                    onChange={(text) => {
                      this.setState({ businessType: text.target.value });
                    }}
                    InputLabelProps={{ style: { color: "grey" } }}
                    SelectProps={{
                      native: true,
                      classes: { icon: classes.icon },
                    }}
                    InputProps={{
                      classes: { notchedOutline: classes.notchedOutline },
                    }}
                  >
                    {btype_arr.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={6}>
                  <TextField
                    style={{ width: "95%" }}
                    variant="outlined"
                    margin="normal"
                    select
                    required
                    label="License Type"
                    type="text"
                    id="licenseType"
                    autoComplete="section-type"
                    value={this.state.licenseType}
                    onChange={(text) => {
                      this.setState({ licenseType: text.target.value });
                    }}
                    InputLabelProps={{ style: { color: "grey" } }}
                    SelectProps={{
                      native: true,
                      classes: { icon: classes.icon },
                    }}
                    InputProps={{
                      classes: { notchedOutline: classes.notchedOutline },
                    }}
                  >
                    {license_arr.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
              <Grid item md={6}>
                <TextField
                  id="licenseNo"
                  label="License Number"
                  className={classes.inputSmall}
                  margin="normal"
                  variant="outlined"
                  value={this.state.licenseNo}
                  onChange={this.handleChange("licenseNo")}
                />
              </Grid>
              <Grid item md={6}>
                <TextField
                  id="addOne"
                  label="Address Line One"
                  className={classes.inputSmall}
                  margin="normal"
                  variant="outlined"
                  value={this.state.addOne}
                  onChange={this.handleChange("addOne")}
                />
              </Grid>
              <Grid item md={6}>
                <TextField
                  id="addTwo"
                  label="Address Line Two"
                  className={classes.inputSmall}
                  margin="normal"
                  variant="outlined"
                  value={this.state.addTwo}
                  onChange={this.handleChange("addTwo")}
                />
              </Grid>
              <Grid item md={6}>
                <TextField
                  id="tfCity"
                  label="City"
                  className={classes.inputSmall}
                  margin="normal"
                  variant="outlined"
                  value={this.state.city}
                  onChange={this.handleChange("city")}
                />
              </Grid>
              <Grid item md={6}>
                <TextField
                  id="tfProvince"
                  label="Province"
                  className={classes.inputSmall}
                  margin="normal"
                  variant="outlined"
                  value={this.state.province}
                  //this.state.province
                  onChange={this.handleChange("province")}
                />
              </Grid>
              <Grid item md={6}>
                <TextField
                  id="tfCountry"
                  label="Country"
                  className={classes.inputSmall}
                  margin="normal"
                  variant="outlined"
                  value={this.state.country}
                  onChange={this.handleChange("country")}
                />
              </Grid>
              <Grid item md={6}>
                <TextField
                  id="postalCode"
                  label="Postal Code"
                  className={classes.inputSmall}
                  margin="normal"
                  variant="outlined"
                  value={this.state.postalCode}
                  onChange={this.handleChange("postalCode")}
                />
              </Grid>
            </Grid>
          </fieldset>
          <fieldset className={classes.fieldset}>
            <legend className={classes.legend_text}>Profile Information</legend>
            <Grid container direction="row" justify="space-evenly">
              <Grid item xs={12}>
                <TextField
                  style={{ width: "98%", marginLeft: "1%" }}
                  variant="outlined"
                  margin="normal"
                  required
                  id="tfName"
                  label="Name"
                  value={this.state.name}
                  onChange={this.handleChange("name")}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-multiline-static"
                label="About"
                multiline
                rows="9"
                value={this.state.about}
                className={classes.textField}
                margin="normal"
                variant="outlined"
                style={{ width: "98%", marginLeft: 10 }}
                onChange={this.handleChange("about")}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="tfWebsite"
                label="Website"
                margin="normal"
                variant="outlined"
                className={classes.inputLarge}
                value={this.state.website}
                onChange={this.handleChange("website")}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="tfBanner"
                label="Banner"
                margin="normal"
                variant="outlined"
                style={{ width: "98%", marginLeft: 10 }}
                value={this.state.banner}
                onChange={this.handleChange("banner")}
              />
            </Grid>

            <Grid
              container
              spacing={24}
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid className={classes.image_viewer}>
                {loadingImage ? (
                  <CircularProgress />
                ) : (
                  <img
                    alt="Not Available"
                    src={logo ? logo : canawhoLogoImgNotFound}
                    style={{ height: "200px", width: "200px" }}
                  />
                )}
              </Grid>
            </Grid>
            <Grid
              container
              spacing={24}
              direction="row"
              justify="center"
              alignItems="center"
              style={{ minWidth: "80%" }}
            >
              <Grid
                item
                xs={8}
                justify="center"
                align="center"
                style={{
                  border: "dashed 2px #979A9B",
                  borderRadius: 8,
                  marginTop: 18,
                  minHeight: "20vh",
                }}
              >
                <Dropzone
                  accept="image/*"
                  onDrop={(acceptedFiles) => {
                    if (acceptedFiles.length === 1) {
                      this.handleDrop(acceptedFiles[0]);
                    } else if (acceptedFiles.length > 1) {
                      // here i am checking on the number of files
                      alert("Only a single image is allowed"); // here i am using react toaster to get some notifications. don't need to use it
                    }
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <Grid {...getRootProps({ className: classes.drop_area })}>
                      <input
                        {...getInputProps()}
                        onChange={this.handleFileChange}
                      />
                      <Typography
                        variant="h6"
                        style={{
                          color: "#000",
                          fontWeight: "600",
                          fontFamily: "Open Sans",
                          fontSize: 14,
                          textTransform: "none",
                        }}
                      >
                        Drop image here or click below!
                      </Typography>
                      <IconButton
                        variant="contained"
                        component="label"
                        style={{ color: "#F6227F" }}
                        aria-label="delete"
                      >
                        <CloudUploadIcon style={{ fontSize: "32px" }} />
                        <Typography
                          variant="h6"
                          className={{
                            color: "#000",
                            fontWeight: "600",
                            fontFamily: "Open Sans",
                            fontSize: 14,
                            textTransform: "none",
                          }}
                        >
                          Upload
                        </Typography>
                      </IconButton>
                    </Grid>
                  )}
                </Dropzone>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              Registered Brand:
              <Switch
                checked={this.state.is_registered}
                onChange={this.handleChangeRegistered}
                value={this.state.is_registered}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                size="medium"
                className={classes.button}
                name="btnSave"
                type="submit"
                onClick={() => this.btnSaveOnClick()}
              >
                <SaveIcon className={classes.leftIcon} />
                Save
              </Button>
              <Button
                variant="contained"
                size="medium"
                className={classes.button}
                onClick={this.btnCancelOnClick}
              >
                <CancelIcon className={classes.leftIcon} />
                Cancel
              </Button>
            </Grid>
          </fieldset>
          {/* </form> */}
        </Grid>
      </div>
    );
  }
}

BrandAdd.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BrandAdd);
